import { Component, computed, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonContent, IonRefresherContent, IonRefresher, RefresherEventDetail } from '@ionic/angular/standalone';
import { IonRefresherCustomEvent } from '@ionic/core';
import { ProfileAnonymousComponent } from 'src/app/components/view/profile-anonymous/profile-anonymous.component';
import { ProfileAuthComponent } from 'src/app/components/view/profile-auth/profile-auth.component';
import { StateService } from 'src/app/services/state.service';
import { AuthService } from 'src/app/services/auth.service';
import { ErrorService } from 'src/app/services/error.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { PullService } from 'src/app/services/pull.service';
import { AmplitudeService } from 'src/app/services/amplitude.service';

@Component({
    selector: 'app-account',
    templateUrl: './account.page.html',
    styleUrls: ['./account.page.scss'],
    imports: [IonContent, CommonModule, FormsModule, ProfileAnonymousComponent, ProfileAuthComponent, IonRefresherContent, IonRefresher]
})
export class AccountPage implements OnInit {
  private $state = inject(StateService);
  private $pull = inject(PullService);
  private $auth = inject(AuthService);
  private $error = inject(ErrorService);
  private $amplitude = inject(AmplitudeService);

  public user = toSignal(this.$state.bUser);
  public authenticated = computed(() => this.user() !== undefined);

  ngOnInit() {
    this.$amplitude.track('NAVIGATE_ACCOUNT');
  }

  async doRefresh(event: IonRefresherCustomEvent<RefresherEventDetail>) {
    await this.$pull.user();
    event.target.complete();
  }

  async login() {
    try {
      await this.$auth.showLogin();
    } catch (error) {
      this.$error.showToast({
        message: "Error logging in with biometrics",
        header: "Error",
        position: "top",
        duration: 2000,
      });
    }
  }

}
